import { render, staticRenderFns } from "./recyclingBinList.vue?vue&type=template&id=7e958828&scoped=true"
import script from "./recyclingBinList.vue?vue&type=script&lang=js"
export * from "./recyclingBinList.vue?vue&type=script&lang=js"
import style0 from "./recyclingBinList.vue?vue&type=style&index=0&id=7e958828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e958828",
  null
  
)

export default component.exports